// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__2z9OH","imageUploader":"EGiftCard_imageUploader__37Spj"};